import moment from "moment";
import "moment/locale/id";
import Vue from "vue";

moment.locale("id");

const format = {
  payload: (options) => {
    const { page, itemsPerPage, sortBy, sortDesc } = options;
    const orders = sortBy.map((sort, i) => {
      return sortDesc[i] ? "-" + sort : sort;
    });

    let payload = {
      Skip: (page - 1) * itemsPerPage,
      Limit: itemsPerPage,
      Orders: orders,
      Filter: {},
      Keyword: "",
    };

    return payload;
  },

  date: (date) => {
    return date ? moment(date).format("DD MMM YYYY") : "-";
  },
  dateMonth: (date) => {
    return date ? moment(date).format("MMMM YYYY") : "-";
  },
  dateTime: (date) => {
    return date ? moment(date).format("DD MMM YYYY HH:mm") : "-";
  },
  UTCDateString(date) {
    return date ? moment(date).format("YYYY-MM-DD") + "T00:00:00.000Z" : "";
  },
  dateRelative: (date) => {
    return date ? moment(date).fromNow() : "-";
  },
  relativeUpdatedDate: (items) => {
    const { CreatedDate, LastUpdatedDate } = items;
    return format.dateRelative(
      !LastUpdatedDate ? CreatedDate : LastUpdatedDate
    );
  },
  currency: (value) => {
    if (typeof value == "string") {
      value = parseFloat(value);
    }

    if (isNaN(value)) {
      return "0";
    }

    return value.toLocaleString("id-ID");
  },
  updatedDate: (items) => {
    const { CreatedDate, LastUpdatedDate } = items;
    return format.dateTime(!LastUpdatedDate ? CreatedDate : LastUpdatedDate);
  },

  keyword: (q = "") => {
    q = q || "";
    if (q == "") return "";
    return q.indexOf("*") >= 0 ? q : `*${q}*`;
  },
  price(value) {
    let val = (value / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  capitalize: function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },
};

Vue.prototype.$format = { ...format };
Vue.filter("capitalize", format.capitalize);
Vue.filter("date", format.date);
Vue.filter("dateTime", format.dateTime);
Vue.filter("dateRelative", format.dateRelative);
Vue.filter("currency", format.currency);

export default format;
